// @flow
import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';
import type { ThunkAction } from '../../types';

export function getCustomerAgencies(
  organisationId: number,
  excludeArchived: boolean = true,
  withSettings: boolean = true
): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/organisation/agencies';
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId,
        excludeArchived,
        withSettings
      }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        const agencies = response.data.agenciesWithAccess;
        dispatch({ type: 'UPDATE_CURRENT_CUSTOMER_AGENCIES', agencies });
        return response;
      },
      error => dispatch(APIError(error, 'Error getting customer Agencies'))
    );
  };
}

export function addAgencyToCustomer(
  organisationId: number,
  agencyId: number,
  agencyName: string,
  isAdmin: boolean = false
): ThunkAction {
  return function(dispatch, getState) {
    const agencyWithAccess = {
      agencyId,
      agencyName,
      permissions: [
        {
          permissionId: 1,
          permissionName: 'User'
        }
      ]
    };

    if (isAdmin) {
      agencyWithAccess.permissions.push({
        permissionId: 2,
        permissionName: 'Admin'
      });
    }

    const endpoint = '/organisation/agencies';
    const options = {
      method: 'POST',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId
      },
      data: agencyWithAccess
    };
    return makeAPICall(endpoint, options).then(
      response => {
        dispatch(getCustomerAgencies(organisationId));
        dispatch(getAgencySettings(organisationId));
        return response;
      },
      error =>
        dispatch(APIError(error, 'Error getting adding agency to customer'))
    );
  };
}

export function getAgencySettings(organisationId: number): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/organisation/agency/settings';
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId
      }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        const { unallocatedAgencies, availablePermissions } = response.data;
        dispatch({
          type: 'UPDATE_CURRENT_CUSTOMER_AGENCY_SETTINGS',
          unallocatedAgencies,
          availablePermissions
        });
        return response;
      },
      error => dispatch(APIError(error, 'Error getting agency settings'))
    );
  };
}

export function removeAgencyFromCustomer(
  organisationId: number,
  agency: Object
): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = `/organisation/agency/${agency.accessId}`;
    const options = {
      method: 'PUT',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId
      },
      data: {
        ...agency,
        isArchived: true
      }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        dispatch(getCustomerAgencies(organisationId));
        dispatch(getAgencySettings(organisationId));
        return response;
      },
      error => dispatch(APIError(error, 'Error removing agency from customer'))
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/customers/agencyCreators.js